<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
  },
  methods:{
  }
};
</script>

<style>


#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.container {
  background: #f1f3f0;
  width: 100%;
  margin: 0 auto;
  height: auto;
  padding: 1% 6%;
}
.left{
  text-align: left;
}
.bgwhite{
  background: white;
}
.darkshadow{
  box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
}
.ivu-input:hover{
  outline:orange;
  border: 1px solid orange;
}
.ivu-input:focus{
  border-color: orange;
  outline: 0;
  box-shadow: 0 0 1px 0.1px orange;
}
.ivu-btn-primary{
 background-color: orange;
    border-color: orange;
}
.ivu-btn-primary:hover{
 background-color: orange;
    border-color: orange;
}
.ivu-btn-text:hover{
  color: orange;
}
</style>



// WEBPACK FOOTER //
// src/App.vue